module.exports = __webpack_public_path__ + "static/2-64324070c91b2680a0267975af10c81a.jpg";